import { domainEventBus } from './DomainEventBus';
import {
    WindowLevelDeltaEvent,
    WindowLevelSetEvent,
} from './WindowingDomainEvents';

/**
 * Subscribes to every bus event that can change a series' window/level
 * (deltas during a drag, absolute sets from presets/reset/restore), filtered
 * by series UID. Consumers re-read `Image3D.windowLevel` on each call —
 * delta events carry no absolute value.
 *
 * @returns an unsubscribe function.
 */
export function subscribeToWindowLevelEvents(
    seriesUid: string,
    onChange: () => void
): () => void {
    const onEvent = (
        event: WindowLevelDeltaEvent | WindowLevelSetEvent
    ): void => {
        if (event.seriesUid === seriesUid) {
            onChange();
        }
    };
    const subscriptions = [
        domainEventBus.subscribe(WindowLevelDeltaEvent.EVENT_TYPE, onEvent),
        domainEventBus.subscribe(WindowLevelSetEvent.EVENT_TYPE, onEvent),
    ];
    return () => {
        subscriptions.forEach((subscription) => subscription.unsubscribe());
    };
}
